// Mantiene tutti gli ID noti una sola volta, reintegra le colonne nuove e
// riporta quelle obbligatorie all'inizio, indipendentemente dalla preferenza.
export function normalizeColumnOrder(order, columnIds, lockedIds = []) {
  const known = new Set(columnIds);
  const seen = new Set();
  return [...lockedIds, ...(Array.isArray(order) ? order : []), ...columnIds]
    .filter((id) => {
      if (!known.has(id) || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
}
